import { IconButton } from "@mui/material";

import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import DownloadingIcon from "@mui/icons-material/Downloading";
import ErrorIcon from "@mui/icons-material/Error";

import { useAppSelector } from "app/hooks";
import { caseViewerSelectors } from "./store/selectors";
import { DossierDeviceStatus } from "types/DossierDeviceStatus";
import { DeviceListVisibilityToggleProps } from "features/devices/DeviceListVisibilityToggle";

export function DossierDeviceListVisibilityToggle(
    props: DeviceListVisibilityToggleProps,
) {
    const dossierDeviceStatus = useAppSelector((state) =>
        caseViewerSelectors.selectSelectedDossierDeviceStatusById(
            state,
            props.deviceId,
        ),
    );

    switch (dossierDeviceStatus) {
        case DossierDeviceStatus.Queued:
            return (
                <IconButton
                    title="The recording information from this device is queued to be fetched"
                    color="primary"
                    disableRipple
                >
                    <PlaylistAddIcon />
                </IconButton>
            );
        case DossierDeviceStatus.CollectingRecordings:
            return (
                <IconButton
                    title="The recording information from this device is being fetched"
                    color="primary"
                    disableRipple
                >
                    <DownloadingIcon />
                </IconButton>
            );
        case DossierDeviceStatus.Ready:
            return (
                <IconButton
                    color={props.isSelected ? "primary" : "default"}
                    onClick={() => props.onChange(!props.isSelected)}
                >
                    {props.isSelected ? (
                        <VisibilityIcon />
                    ) : (
                        <VisibilityOffIcon />
                    )}
                </IconButton>
            );
        case DossierDeviceStatus.Failed:
            return (
                <IconButton
                    title="The recording information from this device could not be fetched"
                    color="primary"
                    disableRipple
                >
                    <ErrorIcon />
                </IconButton>
            );
    }
}
